<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Controle de Acesso"
  [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings"
  p-subtitle="Consulte os dados cadastrados no sistema.">

  <div class="ac-summary">
    <div class="ac-summary-icon">
      <i class="an an-shield-check"></i>
    </div>
    <div class="ac-summary-text">
      <span class="ac-summary-title">Acessos cadastrados</span>
      <span class="ac-summary-hint">Gerencie os registros de acesso dos usuários ao sistema.</span>
    </div>
  </div>

  <po-divider></po-divider>

  <div class="ac-table-wrapper po-mt-2">
    <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
    <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-lg-12" #wppTable
      (p-show-more)="loadMore()" [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
      [p-spacing]="poTableColumnSpacing" [p-loading-show-more]="!isHideLoading" p-container="border"
      p-hide-columns-manager="false" [p-columns]="columns" [p-items]="items">
    </po-table>
  </div>
</po-page-list>

<!-- Modal Registro de Acesso -->
<po-modal #modalAccessLogs p-size="xl" [p-title]="modalAccessLogsTitle" p-icon="po-icon po-icon-list"
  p-click-out="false">
  <div class="ac-modal-content">
    <div class="po-row po-mb-3">
      <po-datepicker-range
        class="po-lg-4 po-md-6 po-sm-12"
        p-label="Filtrar por período"
        p-name="accessLogDateRange"
        [(ngModel)]="accessLogDateRange"
        (p-change)="onAccessLogDateRangeChange()"
        (p-clean)="clearAccessLogDateFilter()"
        p-placeholder-start="Data inicial"
        p-placeholder-end="Data final"
        [p-clean]="true"
        p-help="Selecione o período para filtrar os registros de acesso">
      </po-datepicker-range>
    </div>

    <div class="ac-logs-table-wrapper">
      <po-loading-overlay [hidden]="isHideLoadingAccessLogs"></po-loading-overlay>
      @if (accessLogs.length > 0) {
        <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
          [p-columns]="accessLogsTableColumns" [p-items]="accessLogs" p-hide-columns-manager="true"
          (p-show-more)="loadMoreAccessLogs()" [p-show-more-disabled]="!accessLogsHasMore"
          [p-loading-show-more]="!isHideLoadingAccessLogs">
        </po-table>
      }
      @if (accessLogs.length === 0 && isHideLoadingAccessLogs) {
        <div class="ac-empty-state">
          <i class="an an-magnifying-glass"></i>
          <p>Nenhum registro de acesso encontrado</p>
        </div>
      }
    </div>
  </div>
  <po-modal-footer>
    <po-button p-label="Fechar" p-kind="primary" (p-click)="modalAccessLogs.close()"></po-button>
  </po-modal-footer>
</po-modal>
